var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"c_form_input__label",attrs:{"for":_vm.inputId || null}},[_vm._v("\n  "+_vm._s(_vm.labelText)),(_vm.required)?_c('span',{staticClass:"c_form_input__required_indicator"},[_vm._v("*")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }